import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import URL from '../../utils/helper';

import { Icon, Menu, Dropdown } from 'antd';
import { Container } from './styles';
import {
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper,
  TemplatePageOverview,
  TemplateImage,
  DropdownDetails,
} from '../TemplateSection/styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import Loader from '../../components/Loader';
import CreateNewRefElement from '../../components/Modals/CreateNewRefElement';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';
import { getAllRefElements, getAllEmailElement, getAllFlowElements, getAllBlockElements } from '../../utils/services/elementAPI';
// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import { correctBaseUrl } from '../../utils/svgUtils';
import { getTemplateStatus } from '../../utils/services/templatesAPI';
import LockStatusCheckModal from '../../components/Modals/LockStatusCheckModal';
import { withTranslation } from 'react-i18next';
import { DOCUMENT_AND_EMAIL_ELEMENTS_LIST } from '../TemplateSection/translationValues';
import { checkLockStatus } from '../../utils/services/complexDocumentsAPI';
import TemplateLockedModal from '../ComplexDocumentDesign/TemplateLockedModal';
const NAMESPACES = ['DOCUMENT_AND_EMAIL_ELEMENTS_LIST'];

const generateFlowThumbnail = (id) => `${URL.DESIGN_SYSTEM_URL}standalone/flow/thumbnail/${id}`;
const generateBlockThumbnail = (id) => `${URL.DESIGN_SYSTEM_URL}standalone/block/thumbnail/${id}`;

const ReferenceElements = props => {
  const {
    isReferenced,
    userpage,
    activeTab,
    elementCategories,
    globalSearchVal,
    globalSearchTag,
    isEmailElements,
    activeContent,
    forApproval,
    t,
  } = props;
  const [selectedElement, setSelectedElement] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedAction, setSelectedAction] = useState(null);
  const [modalVisibility, setModalVisibility] = useState(false);
  const [delmodalVisibility, setDelModalVisibility] = useState(false);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [lockedBy, setLockedBy] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [elementsList, setElementsList] = useState([]);
  const [elementsCount, setElementsCount] = useState(null);
  const { loginVisible, checkUserAccess, checkUserAccessRoles, userDetails } = useContext(AppStoreContext);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setElementsList([]);
      setElementsCount(0);
      if (!isEmailElements) {
        let response;
        if(activeContent === 'createFlow') {
        response = await getAllFlowElements(
          1,
          isReferenced,
          activeTab,
          globalSearchVal,
          globalSearchTag,
          'write',
          forApproval,
        );
        } else if(activeContent === 'createBlock') {
          response = await getAllBlockElements(
          1,
          isReferenced,
          activeTab,
          globalSearchVal,
          globalSearchTag,
          'write',
          forApproval,
        );
        }
        if (response) {
          let elementsData = response.data;
          setElementsList(elementsData);
          setElementsCount(response.dataCount);
        }
      } else {
        let response = await getAllEmailElement(
          1,
          isReferenced,
          activeTab,
          globalSearchVal,
          globalSearchTag,
          'write',
        );
        let elementsData = response.data;
        setElementsList(elementsData);
        setElementsCount(response.dataCount);
      }
      setIsLoading(false);
    })();
    // eslint-disable-next-line
  }, [isReferenced, activeTab, globalSearchVal, globalSearchTag, activeContent, forApproval]);

  useEffect(() => {
    setCategoryList(elementCategories);
  }, [elementCategories]);

  useEffect(() => {
    (async () => {
      if (elementsCount > 0) {
        if (elementsList.length !== elementsCount) {
          if (!isEmailElements) {
            let response;
            if (activeContent === 'createFlow') {
              response = await getAllFlowElements(
                userpage,
                isReferenced,
                activeTab,
                globalSearchVal,
                globalSearchTag,
                'write',
                forApproval,
              );
            } else if (activeContent === 'createBlock') {
              response = await getAllBlockElements(
                userpage,
                isReferenced,
                activeTab,
                globalSearchVal,
                globalSearchTag,
                'write',
                forApproval,
              );
            }
            if (response) {
              let elementsData =
                userpage > 1 ? elementsList.concat(response.data) : response.data;
              setElementsList(elementsData);
              setElementsCount(response.dataCount);
            }
          } else {
            let response = await getAllEmailElement(userpage, isReferenced, '', '', '', 'write');
            let elementsData = userpage > 1 ? elementsList.concat(response.data) : response.data;
            setElementsList(elementsData);
            setElementsCount(response.dataCount);
          }
        }
      }
    })();
    // eslint-disable-next-line
  }, [userpage]);

  useEffect(() => {
    if (
      loginVisible === false &&
      Boolean(selectedElement) &&
      Boolean(selectedElement.id) &&
      !Boolean(selectedAction)
    ) {
      if (isEmailElements) {
        history.push(`/emailElementDesign/${selectedElement.id}`);
      } else {
        history.push(`/elementDesign/${selectedElement.id}`);
      }
    }
  }, [loginVisible, selectedElement, selectedAction, history, isEmailElements]);

  const checkTemplateStatus = async template => {
    const payload = {
      resourceId: template.id,
      resourceType: activeContent === 'createFlow' ? 'flow' : 'block',
    }
    let templateStatus;
    if(isEmailElements) {
      templateStatus = await getTemplateStatus(
        template.id,
        isEmailElements ? 'emailElement' : 'printElement',
      );
    } else {
      templateStatus = await checkLockStatus(payload);
    }
    if(!isEmailElements) {
      if(templateStatus.statusCode === 741) {
        if(userDetails.id !== templateStatus.data.userId) {
          setLockedBy(templateStatus.data.userName);
          setSelectedAction('template-locked');
          setUpdateModalVisibility(true);
          return 'template-locked';
        }
      }
    }
    
    if (isEmailElements && templateStatus?.data) {
      const { locked, lockedBy } = templateStatus.data;
        if (userDetails && locked && lockedBy) {
            const locked = userDetails.id !== lockedBy.userId;
        if (locked) {
          setLockedBy(lockedBy);
          setSelectedAction('template-locked');
          setUpdateModalVisibility(true);
          return 'template-locked';
        }
      }
    }
  };

  const enableModalVisibility = async (actionType, template) => {
    const checkStatus = ['delete-template'].some(data => data === actionType);
    if (checkStatus) {
      actionType = (await checkTemplateStatus(template)) || actionType;
    }
    setUpdateModalVisibility(true);
    setDelModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedElement(template);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setModalVisibility(false);
    setDelModalVisibility(false);
    setSelectedAction(null);
    setSelectedElement(null);
  };
  const redirectToRefElement = element => {
    const id = element?.id;
    const blockId = element?.parentBlockId || element?.blockId;

    if (!id && !blockId) return;
  
    if (isEmailElements) {
      return history.push(`/emailElementDesign/${id}`);
    }
  
    const waitingParam = forApproval ? '?waitingForApproval=true' : '';
    let url = '';
  
    if (activeContent === 'createFlow' && id) {
      url = `/flow/${id}${waitingParam}`;
    } else if (activeContent === 'createBlock' && blockId) {
      url = `/block/${blockId}${waitingParam}`;
    }
  
    if (url) history.push(url);
  };

  const onSuccessDeletion = async deleted => {
    setDelModalVisibility(false);
    setUpdateModalVisibility(false);
    if (deleted) {
      setIsLoading(true);
      if (!isEmailElements) {
        let elementResponse;
        if(activeContent === 'createFlow') {
        elementResponse = await getAllFlowElements(
          1,
          isReferenced,
          activeTab,
          globalSearchVal,
          globalSearchTag,
          'write',
        );
        } else if(activeContent === 'createBlock') {
          elementResponse = await getAllBlockElements(
          1,
          isReferenced,
          activeTab,
          globalSearchVal,
          globalSearchTag,
          'write')
        }
        if (elementResponse) {
          if (checkUserAccess('master')) {
            let elementsData = elementResponse.data.masterElements;
            setElementsList(elementsData);
            setElementsCount(elementResponse.data.masterCount);
          } else {
            let elementsData = elementResponse.data;
            setElementsList(elementsData);
            setElementsCount(elementResponse.dataCount);
          }
        }
      } else {
        let response = await getAllEmailElement(
          1,
          isReferenced,
          activeTab,
          globalSearchVal,
          globalSearchTag,
        );
        if (response) {
          let elementsData = response.data;
          setElementsList(elementsData);
          setElementsCount(response.dataCount);
        }
      }
      setIsLoading(false);
    }
  };

  return (
    <Container>
      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <TemplateConatiner>
          <>
            <TemplateWrapper>
              {elementsList &&
                elementsList.length > 0 &&
                elementsList.map(element => {
                  let categoryByElement = {
                    id: element.id || element.parentBlockId || element.blockId,
                    name: element.name || element.flowName || element.parentBlockName,
                  };
                  const thumbnail = correctBaseUrl(element?.thumbnail ? element.thumbnail :
                    activeContent === 'createFlow' ?
                      generateFlowThumbnail(categoryByElement.id) : generateBlockThumbnail(categoryByElement.id));
                  return (
                    <TemplatePageOverview
                      key={element.id || element.parentBlockId || element.blockId}
                      title={element.name || element.flowName || element.parentBlockName}
                      onClick={() => redirectToRefElement(element)}
                    >
                      <TemplateImage refElement={true}>
                        <div className="image-wrapper">
                          <div key={element.id || element.parentBlockId || element.blockId} className="preview-image-div">
                            <img
                              src={thumbnail ? correctBaseUrl(thumbnail) : PageNotFoundIllustration}
                              alt="pageObj-thumbnail"
                              className={!thumbnail ? 'no-thumbnail' : ''}
                            />
                          </div>
                        </div>
                        <DropdownDetails
                          id={`${element.id || element.parentBlockId || element.blockId}-template`}
                          className="dropdown-menu"
                          onClick={e => e.stopPropagation()}
                        >
                          <Dropdown
                            overlay={
                              <Menu>
                                <Menu.Item key="0" onClick={() => redirectToRefElement(element)}>
                                  {t(
                                    DOCUMENT_AND_EMAIL_ELEMENTS_LIST.EDIT_ELEMENT_DROPDOWN_OPTION.key,
                                    DOCUMENT_AND_EMAIL_ELEMENTS_LIST.EDIT_ELEMENT_DROPDOWN_OPTION.value,
                                  )}
                                </Menu.Item>

                                {checkUserAccessRoles(['REUSABLECONTENTMANAGER']) && <Menu.Item
                                  key="1"
                                  onClick={() =>
                                    enableModalVisibility('delete-template', categoryByElement)
                                  }
                                >
                                  {t(
                                    DOCUMENT_AND_EMAIL_ELEMENTS_LIST.DELETE_ELEMENT_DROPDOWN_OPTION.key,
                                    DOCUMENT_AND_EMAIL_ELEMENTS_LIST.DELETE_ELEMENT_DROPDOWN_OPTION.value,
                                  )}
                                </Menu.Item>}
                              </Menu>
                            }
                            trigger={['click']}
                            getPopupContainer={() =>
                              document.getElementById(`${element.id || element.parentBlockId}-template`)
                            }
                          >
                            <Icon type="more" />
                          </Dropdown>
                        </DropdownDetails>
                        {/* )} */}
                      </TemplateImage>
                      <div className="template_name">
                        <div className="name" onClick={() => redirectToRefElement(element)}>
                          {element.name || element.flowName || element.parentBlockName || element.blockName}{' '}
                        </div>
                        <div className="categoryName">
                          <div className="box2"></div>
                          {categoryList.length > 0 &&
                            categoryList.map(category => (
                              <div key={category.categoryId}>
                                {element.categoryId === category.categoryId &&
                                  category.categoryName}
                              </div>
                            ))}
                        </div>
                      </div>
                    </TemplatePageOverview>
                  );
                })}
            </TemplateWrapper>
          </>
          {!isLoading && modalVisibility && !loginVisible && (
            <CreateNewRefElement
              visible={modalVisibility}
              onCancel={disableModalVisibility}
              // onSucess={redirectToRefElement}
              categoryType="template"
            />
          )}
          {!isLoading && delmodalVisibility && !loginVisible && selectedAction !== 'template-locked' && (
            <DeleteTemplateModal
              visible={delmodalVisibility}
              onCancel={disableModalVisibility}
              targetTemplate={selectedElement}
              categoryType={isEmailElements ? 'email-element' : 'element'}
              isElement={true}
              onSucess={onSuccessDeletion}
              activeContent={activeContent}
            />
          )}
          {!isLoading &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            selectedAction === 'template-locked' && isEmailElements && (
              <LockStatusCheckModal
                visible={updateModalVisibility}
                lockedBy={lockedBy}
                onCancel={disableModalVisibility}
              />
            )}
            {!isLoading &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            selectedAction === 'template-locked' && !isEmailElements && (
              <TemplateLockedModal
                visible={selectedAction === 'template-locked'}
                onClose={disableModalVisibility}
                lockedByUser={lockedBy}
                deletion={true} />)}
          {!isLoading && elementsList && elementsList.length === 0 && (
            <EmptySettingsDetails>
              <div className="empty-illustration">
                <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
              </div>
              <div className="empty-txt" style={{ color: 'black', fontSize: '15px' }}>
                <span style={{ fontWeight: 700 }}></span>
                <span> {t(DOCUMENT_AND_EMAIL_ELEMENTS_LIST.ELEMENTS_LIST_EMPTY_TEXT.key, DOCUMENT_AND_EMAIL_ELEMENTS_LIST.ELEMENTS_LIST_EMPTY_TEXT.value)}</span>
              </div>
            </EmptySettingsDetails>
          )}
          {elementsList && (
            <>
              {elementsList.length !== elementsCount && (
                <div className="addMore">
                  <Icon type="loading" />
                  {t(DOCUMENT_AND_EMAIL_ELEMENTS_LIST.LOADING_MORE.key, DOCUMENT_AND_EMAIL_ELEMENTS_LIST.LOADING_MORE.value)}
                </div>
              )}
              {elementsList.length === elementsCount && elementsList.length !== 0 && (
                <div className="allData">
                  {t(DOCUMENT_AND_EMAIL_ELEMENTS_LIST.GOT_ALL_ELEMENTS_LIST.key, DOCUMENT_AND_EMAIL_ELEMENTS_LIST.GOT_ALL_ELEMENTS_LIST.value)}
                </div>
              )}
            </>
          )}
        </TemplateConatiner>
      )}
    </Container>
  );
};

export default withTranslation(NAMESPACES)(ReferenceElements);
